module.exports = __webpack_public_path__ + "static/media/kea-academia.a1bb0ff1.jpeg";